import React from 'react';
import whitelistProps from 'admin-components/utils/whitelistProps';
import { StyledText } from './Text.styles';
import { propTypes, defaultProps, propDescriptions } from './Text.props';

const Text = (props) => <StyledText {...whitelistProps(props, propTypes)} data-id="Text" />;

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;
Text.propDescriptions = propDescriptions;

export default Text;
